<template>
  <div class="q-ma-xs q-mt-xs">
    <div>
      <DataTable ref="DT"
                 :opts="opts"
                 @onSelRow="onSelRow"
                 @onUpdate="onUpdate">
        <template #buttons>
          <q-btn-toggle v-model="subTable"
                        @update:model-value="updateSubTable()"
                        toggle-color="primary"
                        :options="[
                          { label: 'Polizas', value: 'Polizas', disable: true },
                          { label: 'Recibos', value: 'Polizas_Recibos' },
                          { label: 'Siniestros', value: 'Polizas_Siniestros' },
                          { label: 'Notas', value: 'PolizasGestion' }
                        ]" />
        </template>
      </DataTable>
    </div>
  </div>
</template>
<script setup>
import DataTable from "@/lib/DataTable.vue"
import { ref, inject, onMounted, watch } from "vue"
import { useRoute } from "vue-router"
//** CONSTANTES */
const global = inject("global")
const route = useRoute();
const opts = ref({})
const cliente = ref({})
const DT = ref()
const sel = ref(false)
const subTable = ref("Polizas_Recibos");

//**FUNCIONES */
function onUpdate(d) {
  if (d.query === "update" || d.query === "insert")
    global.db("/app/call", { f: "updatePolizas" });
}

function onSelRow(d) {
  if (d) {
    sel.value = !!d
    cliente.value = d;
  }
}

function updateSubTable() {
  DT.value.clearCache()
  opts.value.details[1] = { key: "Poliza", table: subTable.value };
}

async function init() {
  const { id } = route.params
  opts.value = {
    details: [
      { key: "NIF", table: "Clientes_Polizas" },
      { key: "Poliza", table: "Polizas_Recibos" }
    ],
    defs: { Mediador: global.user.area },
    post: {
      table: "Clientes",
      query: "select",
      where: { Mediador: global.user.area }
    }
  };
  id == "Oportunidades" ? opts.value = {
    ...opts.value,
    cols: {Promo: "", FechaPromo: ""},
    post: {
      table: "Clientes",
      query: "select",
      where: { Mediador: global.user.area },
      between: { FechaPromo: { from: '2000-01-01', to: '2999-01-01' } }
    }
  } : "";
  const res = await global.db("/app/db/selClientes", opts.value.post)
  DT.value.updateData(res)
}

onMounted(() => { init() });
watch([route, global.user], () => { init() });
</script>